import React, { useEffect, useState } from "react";


import { loadNotifications, deleteNotification, updateNotification } from "../utils/Network";
import { Link } from "react-router-dom";
import LanguageName from "../components/LanguageName";

export default function NotidicationsContent({ page, urlParams }) {
  const [loading, setLoading] = useState(0);
  const [pageloading, setPageLoading] = useState(false);
  const [Notifications, setNotifications] = useState(null);
  const [Notifications_count, setNotificationsCount] = useState(null);
  const [show_delete, setShowDelete] = useState(false);
  const [count, setCount] = useState(null);
  const [pages, setPages] = useState(null);
  const [filter_title, setFilterTitle] = useState(null);
  const [filter_language, setFilterLanguage] = useState(null);

  var filter_query = window.location.search;
  useEffect(() => {
    setPageLoading(true);
    getData();

    setFilterTitle(urlParams.get("title"));
  }, []);

  function getData() {
    //console.log(filter_query)
    loadNotifications(filter_query, page).then((data) => {
      if (data.results) {
        setNotifications(data.results);
      }
      if (data.count) {
        setNotificationsCount(data.count);
        if (data && data.count) {
          setCount(data.count);
          var page_count =
            data.count % 10 === 0
              ? parseInt(data.count / 10)
              : parseInt(data.count / 10) + 1;
          var pages_array = range(1, page_count);
          setPages(pages_array);
        }
      }
      setPageLoading(false);
    });
  }
  function range(start, end) {
    return Array.apply(0, Array(end)).map((element, index) => index + start);
  }

  const handleDelete = (id, e) => {
    setLoading(id);
    deleteNotification(id).then(() => {
      getData();
    });
  };

  const toggleRead = (e, id, is_Read) => {
    e.preventDefault();
    setLoading(id);
    updateNotification(id, !is_Read).then(() => {
      setLoading(false);
      getData();
    });
  };


  return (
    <>
      <div className="content-wrapper">
        <section class="content-header">
          <h3 class="box-title mt-5"></h3>
          <ol class="breadcrumb">
            <li>
              <a href="dashboard">
                <i class="fa fa-dashboard"></i> Home
              </a>
            </li>
            <li class="active">NotificationsContent</li>
          </ol>
        </section>

        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <div class="box box-primary">
                <div class="box-header with-border">
                  <h3 class="box-title mt-5">
                    All Items &nbsp;
                    <small>({Notifications_count}) items</small>
                  </h3>
                  <a
                    href="testimonial"
                    title="Unread"
                    className="btn btn-info pull-right "
                  >
                    <i className="fa fa-envelope-o"></i>
                  </a>
                  <a
                    href="testimonial"
                    title="Read"
                    className="btn btn-default pull-right  mr-5"
                  >
                    <i className="fa fa-envelope-open-o"></i>
                  </a>
                </div>
                <div className="box-body no-padding ">
                  <form action="" method="get">
                    <table
                      id="example1"
                      className="table table-striped mb-0 notification-table"
                    >
                      <tbody>
                        {Notifications?.map((item) => (
                          <tr
                            key={item.id}
                            className={loading === item.id ? "loading" : ""}
                          >
                            <td>
                              <p>{item.title}</p>
                            </td>

                            <td>
                              {item.created_at.split("T")[0]}
                              <br />
                              {item.created_at.split("T")[1].split(".")[0]}
                            </td>
                            <td className="text-right">
                              <div className="btn-group">
                                <button
                                  type="button"
                                  onClick={(e) => {
                                    handleDelete(item.id, e);
                                  }}
                                  className="btn btn-default btn-sm"
                                >
                                  <i className="fa fa-trash"></i>
                                </button>
                                <a
                                  href={`#/${item.id}`}
                                  onClick={(e)=>{ toggleRead(e,item.id, item.is_Read); }}
                                  className={`btn ${
                                    !item.is_Read ? "btn-info" : "btn-default"
                                  } btn-sm`}
                                >
                                  <i
                                    className={`${
                                      !item.is_Read
                                        ? "fa fa-envelope"
                                        : "fa fa-envelope-open"
                                    } `}
                                  ></i>
                                </a>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </form>
                </div>
              </div>

              <ul className="pagination cms-pagination m-0 float-right">
                <li className="page-item">
                  <Link className="page-link" to="#">
                    «
                  </Link>
                </li>
                {pages &&
                  pages.map((page_number) => (
                    <li key={page_number} className="page-item">
                      <a
                        className={
                          page_number == page ? "page-link active" : "page-link"
                        }
                        href={`Notifications/${page_number}${
                          urlParams ? "?" + urlParams : ""
                        }`}
                      >
                        {page_number}
                      </a>
                    </li>
                  ))}
                <li className="page-item">
                  <Link className="page-link" to="">
                    »
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
